import React from 'react';
import './style.css';
import heart from './heart.svg';
import ReactGA from 'react-ga';

class Footer extends React.Component {
    render () {
        return (
            <footer className="footer rodape">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="footer-bottom-content clearfix">
                                <div className="col-sm-12 col-md-12 no-padding-right">
                                    <div className="footer-bottom-right">
                                        <p>© 2015 - 2018 Neuro. Todos os direitos reservados</p>
                                        <p>Feito com <img src={heart} alt="amor"/> por <span><ReactGA.OutboundLink eventLabel="acessandoGrupoNeuro" to="http://www.gruponeuro.com.br" target="_blank" rel="noopener noreferrer">gruponeuro.com.br</ReactGA.OutboundLink></span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/index.js